export class WayPoint {
    location: LatLong;
    stopover: boolean;
}

export class LatLong {
    lat: number;
    lng: number;
}

export class CustomLabel {
    label: Label;
    infoWindow: string;
}

export class Label {
    color: string;
    text: string;
}

export class RouteNameRefNo {
    refNo: number;
    routeName: string;
}

export class DistanceAndWeather {
    distance: number;
    actualDuration: number;
    trafficDuration: number;
    rafficCondition: string;
    weather: string;
    trafficCondition: string;
}

export class TrafficDetailsDto {
    fromLat: string;
    fromLng: string;
    toLat: string;
    toLng: string;
    requiredWeather: string;
    companyCode: number;
}